var map = {
	"./computerscience/1.png": 8235,
	"./computerscience/2.png": 4567,
	"./computerscience/3.png": 659,
	"./computerscience/4.png": 6302,
	"./computerscience/5.png": 1369,
	"./computerscience/6.png": 4303,
	"./cooperation/1.png": 8945,
	"./cooperation/2.png": 5934,
	"./cooperation/3.png": 8290,
	"./cooperation/4.png": 5303,
	"./cooperation/5.png": 2411,
	"./cooperation/6.png": 8187,
	"./git/1.png": 9034,
	"./git/2.png": 5565,
	"./git/3.png": 1765,
	"./git/4.png": 7738,
	"./git/5.png": 1675,
	"./git/6.png": 8991,
	"./htmlcss/1.png": 1459,
	"./htmlcss/2.png": 6853,
	"./htmlcss/3.png": 7743,
	"./javascript/1.png": 1344,
	"./javascript/2.png": 3770,
	"./javascript/3.png": 9956,
	"./javascript/4.png": 9749,
	"./javascript/5.png": 2646,
	"./javascript/6.png": 7263,
	"./react/1.png": 9803,
	"./react/2.png": 4956,
	"./react/3.png": 6057,
	"./react/4.png": 6426,
	"./react/5.png": 238,
	"./react/6.png": 604,
	"./typescript/1.png": 5550,
	"./typescript/2.png": 8410,
	"./typescript/3.png": 9023
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8296;